// Generische Card — Dark, mit Glow + Hover.
// Lesbare Texte: slate-100 für Titel, slate-300 für Subtitles.

import { ReactNode } from "react";

interface CardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  accent?: "neutral" | "green" | "yellow" | "red" | "blue";
  className?: string;
  flush?: boolean;
}

const ACCENT_GLOW: Record<NonNullable<CardProps["accent"]>, string> = {
  neutral: "card-glow",
  green: "card-glow-accent-green",
  yellow: "card-glow-accent-yellow",
  red: "card-glow-accent-red",
  blue: "card-glow-accent-blue",
};

const ACCENT_DOT: Record<NonNullable<CardProps["accent"]>, string> = {
  neutral: "bg-slate-500",
  green: "bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.6)]",
  yellow: "bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.6)]",
  red: "bg-rose-400 shadow-[0_0_8px_rgba(244,63,94,0.6)]",
  blue: "bg-sky-400 shadow-[0_0_8px_rgba(56,189,248,0.6)]",
};

export default function Card({
  title,
  subtitle,
  children,
  accent = "neutral",
  className = "",
  flush = false,
}: CardProps) {
  return (
    <section
      className={`
        relative rounded-2xl backdrop-blur
        ${ACCENT_GLOW[accent]}
        ${flush ? "" : "p-4 sm:p-5"}
        ${className}
      `}
    >
      <header
        className={`flex items-baseline justify-between gap-3 ${flush ? "px-4 sm:px-5 pt-4 sm:pt-5 mb-3" : "mb-3"}`}
      >
        <h2 className="text-sm font-semibold flex items-center gap-2 text-slate-100">
          <span className={`h-1.5 w-1.5 rounded-full ${ACCENT_DOT[accent]}`} />
          {title}
        </h2>
        {subtitle && <span className="text-xs text-slate-300 truncate font-medium">{subtitle}</span>}
      </header>
      <div className="text-sm text-slate-200">{children}</div>
    </section>
  );
}
